import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts'

const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null
    const data = payload[0].payload

    return (
        <div className="bg-white border border-gray-100 rounded-xl shadow-lg px-4 py-3">
            <p className="text-sm font-semibold text-gray-700">{data.specie_name}</p>
            <p className="text-sm text-emerald-600 mt-1">
                Arbres plantés : <span className="font-bold">{data.species_number}</span>
            </p>
        </div>
    )
}

const SpeciesObjectiveChart = ({ speciesBreakdown = [], objectif = 0 }) => {
    const maxSpeciesValue = Math.max(...speciesBreakdown.map((s) => s.species_number), 0)
    const yMax = Math.ceil(Math.max(objectif, maxSpeciesValue) / 200) * 200 + 200

    const ticks = []
    for (let i = 0; i <= yMax; i += 200) {
        ticks.push(i)
    }

    return (
        <div className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className="flex items-center justify-between mb-4">
                <p className="font-semibold text-gray-800">Répartition par espèce</p>
                <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span className="flex items-center gap-1.5">
                        <span className="w-3 h-3 rounded-sm bg-emerald-500 inline-block" />
                        Arbres plantés
                    </span>
                    <span className="flex items-center gap-1.5">
                        <span
                            className="w-3 h-[2px] bg-red-400 inline-block"
                            style={{ borderTop: '2px dashed #f87171' }}
                        />
                        Objectif
                    </span>
                </div>
            </div>

            <div className="w-full h-[300px]">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={speciesBreakdown}
                        margin={{ top: 10, right: 40, left: 0, bottom: 30 }}
                        barCategoryGap="30%"
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
                        <XAxis
                            dataKey="specie_name"
                            tick={{ fontSize: 11, fill: '#6b7280' }}
                            interval={0}
                            angle={-12}
                            textAnchor="end"
                            height={50}
                            axisLine={{ stroke: '#e5e7eb' }}
                            tickLine={false}
                        />
                        <YAxis
                            domain={[0, yMax]}
                            ticks={ticks}
                            tick={{ fontSize: 11, fill: '#9ca3af' }}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip cursor={{ fill: '#f9fafb' }} content={<CustomTooltip />} />
                        <Bar dataKey="species_number" fill="#10b981" radius={[8, 8, 0, 0]} maxBarSize={48} />
                        <ReferenceLine
                            y={objectif}
                            stroke="#f87171"
                            strokeWidth={1.5}
                            strokeDasharray="6 4"
                            label={{
                                value: `Objectif : ${objectif}`,
                                position: 'insideTopRight',
                                fill: '#ef4444',
                                fontSize: 11,
                                fontWeight: 600
                            }}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default SpeciesObjectiveChart
